import { Grid } from "@mui/material";
import React from "react";
import { Helmet } from "react-helmet";
import WSDataGrid, { IColumns } from "../../Components/DataGrid/WSDataGrid";
import { getPermissions } from "../../commonFunctions/PermissionManger";
import {
  callAPI,
  IRoleMain,
  MasterPages,
  Method
} from "../../commonFunctions/CommonFunctions";
import { Header, IHeaderActions } from "../../Components/Header/Header";
import ClientModal from "./ClientModal";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import { useDispatch } from "react-redux";
import { resetDataComponent } from "../../StateManagement/actions";
import ConfirmationPopup from "../../Components/Confirmation/Confirmation";

const ClientList: React.FC<any> = React.memo((props) => {
  const { showMessage } = useSnackbar();
  const dispatch = useDispatch();
  // const { edit } = getPermissions(MasterPages.Users, IRoleMain.Masters);
  
  const [modalOpen, setModalOpen] = React.useState(false); //for create / update
  const [isPopupOpen, setPopupOpen] = React.useState(false); //for delete;
  const [selectedIdForUpdate, setSelectedIdForUpdate] =
    React.useState<any>(null);
  const [selectedIdForDlt, setSelectedIdForDlt] = React.useState<any>(null);

  const source = {
    url: "clients/search",
    page: 1,
    pageSize: 10,
    filter: [],
    sort: []
  };

  const handleAction = (action: string, row: any) => {
    if (action === "Edit") {
      setModalOpen(true);
      setSelectedIdForUpdate(row?._id);
    } else if (action === "Delete") {
      setPopupOpen(true);
      setSelectedIdForDlt(row?._id);
    }
  };

  const handleDelete = () => {
    dispatch(resetDataComponent("clientGrid"));
    showMessage("Client deleted successfully!", "success");
  };

  const handleClick = () => {
    setModalOpen(true);
  };

  const handleData = async (formData: any) => {
    try {
      const method = selectedIdForUpdate ? Method.PUT : Method.POST;
      const url = selectedIdForUpdate
        ? `clients/update/${selectedIdForUpdate}`
        : "clients/create";

      const response: any = await callAPI(url, method, formData);

      if (response.success) {
        showMessage(response?.message, "success");
        dispatch(resetDataComponent("clientGrid"));
      }
    } catch (error: any) {
      if (error.message === 'GlobalHandledError') return;
      showMessage(
        error.response?.data.message || "An unexpected error occurred",
        "error"
      );
    } finally {
      setModalOpen(false);
    }
  };

  const handleClose = () => {
    setModalOpen(false);
  };

  const columns: IColumns[] = [
    {
      header: "Client Name",
      fieldName: "name",
      tooltip: true,
      sortable: true
    },

    {
      header: "Email Address",
      fieldName: "email",
      tooltip: true
    },

    {
      header: "Phone Number",
      fieldName: "phone",
      tooltip: true
    },

    {
      header: "Created Date",
      fieldName: "createdAt",
      type: "date",
      tooltip: true,
      sortable: true
    },

    {
      header: "Grand Total",
      fieldName: "grandTotal",
      tooltip: true,
      sortable:true
    },
    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: ["Edit", "Delete"],
      actionCallback: (action, row) => handleAction(action, row)
    }
  ];

  const action: IHeaderActions = {
    type: "button",
    text: "+ New Client",
    size: "medium",
    onClick: handleClick,
    variant: "contained",
    color: "warning",
    sx: {
      backgroundColor: "#FF6B2C",
      textTransform: "none",
      "&:hover": { backgroundColor: "#e65c1d" }
    }
  };

  return (
    <>
      <Helmet>
        <title>Clients | Willsoar Technologies</title>
        <meta
          name="description"
          content="Manage all your clients in one place. View, add, or edit client information easily."
        />
      </Helmet>
      <Grid p={2}>
        <Header
          type="dashboard"
          title="Clients"
          id={"clientHeader"}
          action={action}
          search={true}
        />

        <Grid container spacing={2}>
          <Grid item xs={12}>
            <WSDataGrid
              id="clientGrid"
              columns={columns}
              source={source}
              // info={`${totalCount || 0} Total Records`}
              exportCsv
            />
          </Grid>
        </Grid>

        <ClientModal
          id={selectedIdForUpdate}
          open={modalOpen}
          onClose={handleClose}
          onCreate={handleData}
        />

        {isPopupOpen && (
          <ConfirmationPopup
            apiUrl={"clients/delete"}
            id={selectedIdForDlt}
            confirmMessage="Are you sure you want to delete this client?"
            open={isPopupOpen}
            onClose={() => setPopupOpen(false)}
            onConfirm={handleDelete}
            permanent
          />
        )}
      </Grid>
    </>
  );
});


export default ClientList;